import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d54d152c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "user-icon",
  "data-test": "orcas-migration-user-menu-button"
}

import { computed } from 'vue'
import { getStateData } from '@/store/getters'


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyAvatar',
  setup(__props) {

function getInitials(name: string) {
  const [first, ...last] = name?.trim().split(' ') || ['']

  return `${first?.charAt(0) || ''}${
    last?.at(-1)?.charAt(0) || ''
  }`.toUpperCase()
}

const companyName = computed(() => getStateData().company?.name || '')
const initials = computed(() => getInitials(companyName.value))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(initials.value), 1 /* TEXT */))
}
}

})